import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useGet } from "~/service/index";
import { useGet as useGetLanding } from "~/service/landing.api";
interface ResponseData {
  user: User;
}
interface TenantOrder {
  id: number;
  payment_method: string;
  plan: {
    name: string;
    price: number;
  };
}
interface Tenant {
  id: number;
  slug: string;
  subdomain: string;
  company_name: string;
  status: string;
  order: TenantOrder[];
}
interface Role {
  id: number;
  name: string;
}
interface Department {
  id: number;
  name: string;
}
interface Positions {
  id: number;
  name: string;
  slug: string;
}
interface User {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  gender?: string;
  birthday?: string;
  authorized?: number;
  marital_status?: string | null;
  address?: string | null;
  role?: Role;
  departments?: Department[];
  positions?: Positions[];
  images?: any[];
  about?: null;
  tenant?: Tenant;
}
export const useAuthStore = defineStore("auth", () => {
  const isLoadingMe = ref(false);
  const user = ref<User | null>({ first_name: "", last_name: "" });
  const permissions = ref<string[]>([]);
  const permissionsC = computed(() => {
    return permissions.value;
  });
  async function getUser() {
    try {
      isLoadingMe.value = true;
      const response = await useGet<ResponseData>("/me");
      isLoadingMe.value = false;
      user.value = response?.data?.user;
      return response;
    } catch (e) {
      isLoadingMe.value = false;
      throw e;
    }
  }

  async function getUserForLanding() {
    try {
      isLoadingMe.value = true;
      const response = await useGetLanding<ResponseData>("/me");
      isLoadingMe.value = false;
      user.value = response?.data?.user;
      return response;
    } catch (e) {
      isLoadingMe.value = false;
      return e;
    }
  }

  return {
    getUser,
    getUserForLanding,
    user,
    isLoadingMe,
    permissions,
    permissionsC,
  };
});
